import React, { useState, useEffect } from 'react';
import '../../styles/christmas.css';

/**
 * Christmas Banner component - displays a dismissible festive banner
 * Uses localStorage to remember dismissal
 */
const ChristmasBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the banner
    const isDismissed = localStorage.getItem('christmas-banner-dismissed');
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('christmas-banner-dismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="christmas-banner" role="banner">
      <div className="christmas-banner-content">
        <span className="christmas-banner-icon">🎄</span>
        <span className="christmas-banner-text">
          Happy Holidays from ClimbCapital! Wishing you prosperity in the new year!
        </span>
        <span className="christmas-banner-icon">🎁</span>
      </div>
      <button
        onClick={handleDismiss}
        className="christmas-banner-close"
        aria-label="Close banner"
      >
        ✕
      </button>
    </div>
  );
};

export default ChristmasBanner;
